import { SHORTHAND_PROPERTIES_THAT_EXPAND_TO_COLOR } from '../../../../../apis/services/editActionsServices/nativeActions/globalDesign/constants';
import { STYLE_NAMESPACE } from '../../../../../apis/services/editActionsServices/nativeActions/globalDesign/types';
import { LeadingStyleGroup } from '../../../types';
import { PropertyMetadata } from '../../abstractStyles/types';

const SHORTHAND_PROPERTIES_THAT_EXPAND_TO_COLOR_SET = new Set<string>(
  SHORTHAND_PROPERTIES_THAT_EXPAND_TO_COLOR,
);

const isShorhandInCustomProperties = (
  metadataRecord: Record<string, PropertyMetadata>,
): boolean => {
  return Object.values(metadataRecord).some(
    (metadata) =>
      metadata.namespace === STYLE_NAMESPACE.CssCustomProperties &&
      SHORTHAND_PROPERTIES_THAT_EXPAND_TO_COLOR_SET.has(
        metadata.cssPropertyType,
      ),
  );
};

/**
 * Checks if brand colors should be supported for a leading group.
 * If the leading group or any of its subset groups uses shorthands in cssCustomProperties namespace,
 * returns false. Otherwise, returns true.
 */
export const getIsBrandColorSupported = (
  leadingGroup: LeadingStyleGroup,
): boolean => {
  if (
    isShorhandInCustomProperties(leadingGroup.engine.getAllValues().metadata)
  ) {
    return false;
  }

  return !leadingGroup.subsetGroups.some((subset) =>
    isShorhandInCustomProperties(subset.engine.getAllValues().metadata),
  );
};
